import { formatCurrencyValue, percentageOfCompletion } from '../number.helpers'
import { ONYX_LEVEL_ID } from './staking.helpers'

const calcMembershipStatusProgress = ({ userTier, tierRequirement }) => {
  const currentStakedValue = parseFloat(userTier.totalFiatValue)
  const current = formatCurrencyValue(currentStakedValue, 2)
  const total = formatCurrencyValue(tierRequirement?.fiatThreshold, 2)
  const completed = percentageOfCompletion(current, total)
  return {
    current,
    total,
    completed
  }
}

const buildTiersToPurchase = ({ tiers, userTier, currentUserPoints }) => {
  const userTierId = userTier?.tier?.id
  const rows = tiers
    .filter(({ id }) => id > ONYX_LEVEL_ID)
    .map(({ id, name, pointCost }) => ({
      id,
      name,
      pointCost,
      isDisabled: id <= userTierId || currentUserPoints < pointCost
    }))
  const hasAffordableHigherTier = tiers.some(
    ({ id, pointCost }) => id > userTierId && pointCost < currentUserPoints
  )
  return {
    noPoints: !hasAffordableHigherTier,
    tiers: rows
  }
}

export { calcMembershipStatusProgress, buildTiersToPurchase }
